import { NotSentRemindersCountDto } from '@shared/core/events'
import ms from 'ms'
import { useQuery, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { ApiService } from 'src/services/api.service'

export const GET_NOT_SENT_REMINDERS_COUNT_CACHE_KEY = 'get-not-sent-reminders-count'

export function useNotSentRemindersCount(options?: UseQueryOptions<NotSentRemindersCountDto>) {
  const handleRetry = useHandleRetry()

  return useQuery(GET_NOT_SENT_REMINDERS_COUNT_CACHE_KEY, () => ApiService.Events.getNotSentRemindersCount(), {
    staleTime: ms('5m'),
    retry: handleRetry,
    ...options,
  })
}
